module.exports = __webpack_public_path__ + "img/help_content1.701aef96.png";